import { render } from "./resetPwd.vue?vue&type=template&id=62f7d322&scoped=true"
import script from "./resetPwd.vue?vue&type=script&lang=js"
export * from "./resetPwd.vue?vue&type=script&lang=js"

import "./resetPwd.vue?vue&type=style&index=0&id=62f7d322&lang=scss&scoped=true"

import exportComponent from "E:\\项目对接\\parent-reporting-backend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f7d322"]])

export default __exports__